export default __webpack_public_path__ + "static/media/wx.3247ec60.jpg";